import { compose } from 'redux'

import { withI18n } from 'shared/utils/withI18n'
import Flag from 'views/components/atoms/Flag'
import IconCircleInfo from 'views/components/atoms/Icon/IconCircleInfo'
import IconCircleInfoOutline from 'views/components/atoms/Icon/IconCircleInfoOutline'
import { i18nType } from 'views/utils/propTypes'

const NowLabel = ({ i18n, outlinedIcon }) => (
  <Flag label={i18n._('product.label.nowProductGroup')} nowWidget>
    <div className="u-padding-x-small--left l-flex m-NowWidget__icon-wrapper">
      {outlinedIcon ? (
        <IconCircleInfoOutline size="x-small" />
      ) : (
        <IconCircleInfo size="x-small" />
      )}
    </div>
  </Flag>
)

NowLabel.propTypes = {
  i18n: i18nType.isRequired,
  outlinedIcon: false,
}

export default compose(withI18n())(NowLabel)
